(() => {
  if (window.productPersonalisationInitialized) return;
  window.productPersonalisationInitialized = true;

  const getPersonalisation = (element) => element.closest('[data-product-personalisation]');

  const updateCount = (personalisation, input) => {
    const count = personalisation.querySelector('[data-product-personalisation-count]');
    if (count) count.textContent = input.value.length;
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-product-personalisation-toggle]');
    if (!toggle) return;

    const personalisation = getPersonalisation(toggle);
    const panel = personalisation?.querySelector('[data-product-personalisation-panel]');
    if (!personalisation || !panel) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;

    const icon = toggle.querySelector('.product-personalisation__icon');
    if (icon) icon.textContent = expanded ? '+' : '−';
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-product-personalisation-input]')) return;

    const personalisation = getPersonalisation(event.target);
    if (personalisation) updateCount(personalisation, event.target);
  });

  document.querySelectorAll('[data-product-personalisation]').forEach((personalisation) => {
    const input = personalisation.querySelector('[data-product-personalisation-input]');
    if (input) updateCount(personalisation, input);
  });
})();
